<div class="container-fluid background">
  <div style="float: left; width: 40%; margin-top: 20px; margin-left:25px">
    <div class="card bg-light">
      <div class="card-header">Clasificación por campo</div>
      <div class="card-body">
        <div *ngIf="loadingClassificationChart" class="loading">
          Cargando...
        </div>
        <div *ngIf="!loadingClassificationChart" style="display: block;">
          <canvas baseChart [colors]="classificationChart.pieChartColors" [data]="classificationChart.pieChartData"
            [labels]="classificationChart.pieChartLabels" [chartType]="classificationChart.pieChartType"
            [options]="classificationChart.pieChartOptions" [plugins]="classificationChart.pieChartPlugins"
            [legend]="classificationChart.pieChartLegend">
          </canvas>
        </div>
      </div>
    </div>
  </div>
  <div style="float: left; width: 40%; margin-top: 20px; margin-left: 25px;">
    <div class="card bg-light">
      <div class="card-header">Hectáreas por sucursal</div>
      <div class="card-body">
        <div *ngIf="loadingBranchOfficeChart" class="loading">
          Cargando...
        </div>
        <div *ngIf="!loadingBranchOfficeChart" style="display: block;">
          <canvas baseChart [data]="branchOfficeChart.pieChartData" [labels]="branchOfficeChart.pieChartLabels"
            [chartType]="branchOfficeChart.pieChartType" [options]="branchOfficeChart.pieChartOptions"
            [plugins]="branchOfficeChart.pieChartPlugins" [legend]="branchOfficeChart.pieChartLegend">
          </canvas>
        </div>
      </div>
    </div>
  </div>
  <div style="clear: both;"></div>
  <div>
    <div style="width: 40%; margin-top: 20px; margin-left: 25px;">
      <div class="card bg-light">
        <div class="card-header">Hectáreas por operador comercial</div>
        <div class="card-body">
          <div *ngIf="loadingAdvisorChart" class="loading">
            Cargando...
          </div>
          <div *ngIf="!loadingAdvisorChart" style="display: block;">
            <canvas baseChart [data]="branchAdvisorChart.pieChartData" [labels]="branchAdvisorChart.pieChartLabels"
              [chartType]="branchAdvisorChart.pieChartType" [options]="branchAdvisorChart.pieChartOptions"
              [plugins]="branchAdvisorChart.pieChartPlugins" [legend]="branchAdvisorChart.pieChartLegend">
            </canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
